(function() {
	/**
	 * Renders Frequently Asked Questions (FAQ) Search Page
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object} 	Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderFaqFacetsPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var hash = props.context.hash;
		var parameters = props.context.querystring;
		var faqcoll = WebBaseAprovLV.config.noovleSearchCollection + 'faq';
		var defaultsearchterm = '';
		// dirty workaround, will be fixed
		hash = hash.replace(new RegExp('%7C', 'g'), '%257C');
		hash = hash.replace(new RegExp('%28', 'g'), '%2528');
		hash = hash.replace(new RegExp('%29', 'g'), '%2529');
		hash = hash.replace(new RegExp('%2E', 'g'), '%252E');
		hash = hash.replace(new RegExp('%3A', 'g'), '%253A');
		hash = hash.replace(new RegExp('%2B', 'g'), '%252B');
		if ((hash.includes('q=') && hash.toLowerCase().indexOf('q=&') === -1) && (hash.length > 3)) {
			defaultsearchterm = '';
		} else {
			defaultsearchterm = '&q=faq_item';
		}
		switch (true) {
			case /^de/i.test(WebBaseAprovLV.lang):
				parameters = 'site=' + faqcoll + '_de&proxystylesheet=json_ext&client=faq_de&lang=d&getfields=*&filter=0' + defaultsearchterm + '&' + hash;
				break;
			case /^it/i.test(WebBaseAprovLV.lang):
				parameters = 'site=' + faqcoll + '_it&proxystylesheet=json_ext&client=faq_it&lang=i&getfields=*&filter=0' + defaultsearchterm + '&' + hash;
				break;
			case /^l?ld/i.test(WebBaseAprovLV.lang):
				parameters = 'site=' + faqcoll + '_de&proxystylesheet=json_ext&client=faq_de&lang=l&getfields=*&filter=0' + defaultsearchterm + '&' + hash;
				break;
		}
		var model = {
			element: null,
			template: 'templates/faq-facets.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				pageContent: null,
				searchResults: null,
				searchParams: null,
				navRaw: null,
				nav: null
			}
		};
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			WebBaseAprovLV.Utils.getSearchData(parameters),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
		.then(function(pageXhr, searchXhr, tmplPage, tmplBreadcrumb, tmplSidebar) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
			var searchRaw = Array.isArray(searchXhr) ? searchXhr[0] : (searchXhr || {});
			model.data.navRaw = {};
			var collections = {};
			model.data.pageRaw = pageRaw;
			if (model.data.pageRaw) {
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
					searchResults: searchRaw,
					searchParams: parameters,
					nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
					collections: collections
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			}
			return $.Deferred().reject(model);
		}).promise();
	};
})();
